import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../context/NotificationsContext";
import { ACTION_TYPE_CONFIG, buildRelated, toRelatedTarget, relatedOpensPage, timeAgo } from "../../utils/notificationsDisplay";
import "./NotificationsDropdown.css";

function NotificationsDropdown({ onClose, onOpenRelated }) {
  const navigate = useNavigate();
  const { recent, unreadTotal, markAsRead, markAllAsRead } = useNotifications();

  const handleRowClick = (n) => {
    if (!n.is_read) markAsRead(n.id, n.entity_type, n.entity_id);
    const related = buildRelated(n);
    onClose();
    if (!related?.link) return;
    // Store notifications go to the page that shows the problem; the rest open
    // the details modal in place.
    if (relatedOpensPage(n.entity_type)) navigate(related.link);
    else onOpenRelated(toRelatedTarget(n));
  };

  return (
    <div className="admin-notifications-dropdown">
      <div className="admin-notifications-dropdown-header">
        <strong>Notifications</strong>
        {unreadTotal > 0 && (
          <button className="admin-notifications-mark-all-btn" onClick={() => markAllAsRead()}>
            Mark all as read
          </button>
        )}
      </div>

      <div className="admin-notifications-dropdown-list">
        {recent.length === 0 ? (
          <div className="admin-notifications-dropdown-empty">No notifications yet.</div>
        ) : (
          recent.map((n) => {
            const cfg = ACTION_TYPE_CONFIG[n.action_type] || ACTION_TYPE_CONFIG.updated;
            return (
              <button
                key={n.id}
                className={`admin-notifications-dropdown-row ${!n.is_read ? "unread" : ""}`}
                onClick={() => handleRowClick(n)}
              >
                <div className={`admin-notifications-dropdown-icon ${cfg.cssClass}`}>
                  <i className={cfg.icon}></i>
                </div>
                <div className="admin-notifications-dropdown-text">
                  <span className="admin-notifications-dropdown-desc">{n.description}</span>
                  <span className="admin-notifications-dropdown-meta">{timeAgo(n.created_at)}</span>
                </div>
                {!n.is_read && <span className="admin-notifications-dropdown-dot" />}
              </button>
            );
          })
        )}
      </div>

      <button
        className="admin-notifications-dropdown-viewall"
        onClick={() => { onClose(); navigate("/notifications"); }}
      >
        View all
      </button>
    </div>
  );
}

export default NotificationsDropdown;
